import { formatDateEn } from "@repo/shared"
import IconFont from "@repo/ui/iconfont"
import { CycleList } from "common/helper/const"
import { ReportsItem } from "common/interface/interface"
import { cdn } from "common/utils/cdn"
import Link from "next/link"
import React from "react"

import Style from "./index.module.scss"

interface ItemProps {
	info: ReportsItem
	locale: string
}

const CardItem: React.FC<ItemProps> = ({ info, locale }) => {
	const slug = info.name
		?.trim()
		.toLowerCase()
		.replace(/\s+/g, "-")
		.replace(/[^a-z0-9\-._~]/g, "")
	const formatUpdateDate = (date: number, isStopped: number) => {
		if (isStopped === 1) {
			return "Stop Update"
		}
		if (!date) {
			return "No Update Yet"
		}
		return `${formatDateEn(date * 1000)} Update`
	}
	return (
		<div key={info.id} className={Style.card}>
			<Link
				href={info.view_url ? info.view_url : `/${locale}/${info.id}-${slug}`}
				target={"_blank"}
				className={Style.cardLink}
			>
				<div className={Style.thumbnailContainer}>
					<img
						src={info.cover_pic || `${cdn()}/images/index/report_card.png`}
						alt={info.name}
						className={Style.thumbnail}
					/>
					<div className={Style.updateTag}>
						{info.is_stop !== 1 && !!info.last_updated_time && (
							<IconFont
								type="icon-a-Historylishijilu"
								style={{
									fill: "#fff",
									width: "14px",
									height: "14px",
								}}
							/>
						)}
						{formatUpdateDate(info.last_updated_time, info.is_stop)}
					</div>
				</div>
				<div className={Style.cardContent}>
					<h3 className={Style.cardTitle}>{info.name}</h3>
					<div className={Style.cardMeta}>
						<span>{info.item_en_name}</span>
						<span>/</span>
						<span>{CycleList.find((i) => i.id === info.cycle)?.en_name}</span>
					</div>
				</div>
			</Link>
		</div>
	)
}

export default CardItem
